import { useEffect, useRef } from 'react';
import SessionStorage from '../utils/SessionStorage';

// Should be included in head.html as part of window.digitalData.spaData
type TSpaTrackingData = {
    inSpaFlow?: boolean,
    currentSpaPage?: string,
    trackingId?: string | null,
}

export const useSpaTracking = () => {
    const spaData = useRef(window?.digitalData?.spaData as TSpaTrackingData);

    useEffect(() => {
        const fetchHandle = setInterval(() => {
            if (window?.digitalData?.spaData) {
                spaData.current = window.digitalData.spaData;
                spaData.current.inSpaFlow = true;
                spaData.current.trackingId = SessionStorage.getObject('initResponse')?.SessionId;
                clearInterval(fetchHandle);
            }
        }, 100);
    }, []);

    const updateSpaPage = (nextPage: string) => {
        if (spaData.current !== undefined 
            && spaData.current.currentSpaPage !== undefined
            && spaData.current.currentSpaPage !== nextPage
        ) {
            spaData.current.currentSpaPage = nextPage;
        }
    };

    const updateSpaTrackingId = (nextTrackingId: string) => {
        if (spaData.current !== undefined
            && spaData.current.trackingId !== undefined
            && spaData.current.trackingId !== nextTrackingId
        ) {
            spaData.current.trackingId = nextTrackingId;
        }
    };

    return {
        updateSpaPage,
        updateSpaTrackingId,
    };
};

export default useSpaTracking;